<template>
  <div>
    <PageHeader>
      <template v-slot:header>ランク設定</template>
      <template v-slot:annotation>
        評価点数のランクを設定します。各ランク名称、評価点数の範囲を設定することができます。
      </template>
    </PageHeader>

    <v-row>
      <v-col cols="6" sm="6" md="4" lg="2">
        <Button @click="onClickRankSettingEditOpen(null)" color="primary"
          >新規追加</Button
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          @click:row="onClickRankSettingEditOpen"
          :loading="loading"
          loading-text="読み込み中..."
          no-data-text="ランク設定情報は見つかりませんでした。新規追加ボタンよりランクを設定してください。"
        >
        </v-data-table>
      </v-col>
    </v-row>
    <Loader :loading="loading" />
    <RankSettingEdit
      ref="edit"
      @edit="editRankSettingInfo"
      @closeEdit="closeEdit"
    />
    <DialogMessage ref="dialog" />
  </div>
</template>

<script>
import RankSettingEdit from './RankSettingEdit.vue';
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import { getSessionStorageItem } from '../../../common.js';

export default {
  name: 'BehavioralElement',
  components: { RankSettingEdit },

  data() {
    return {
      loading: false,
      items: [],

      headers: [
        {
          text: '表示順',
          align: 'left',
          value: 'SHOW_ORDER',
        },
        {
          text: 'ランク設定名',
          align: 'left',
          value: 'RANK_SETTING_NAME',
        },

        {
          text: '評価得点開始',
          align: 'right',
          value: 'RANK_SCORE_START',
        },

        {
          text: '評価得点終了',
          align: 'right',
          value: 'RANK_SCORE_END',
        },
      ],
    };
  },

  created() {
    this.getRankSetting();
  },

  methods: {
    onClickRankSettingEditOpen(item) {
      // ランク設定編集画面を表示
      if (item == null) {
        this.$refs.edit.open(null, { color: 'red' });
      } else {
        this.$refs.edit.open(item, { color: 'red' });
      }
    },
    editRankSettingInfo() {
      // ランク設定情報取得
      this.getRankSetting();
    },
    async getRankSetting() {
      this.loading = true;

      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      let vm = this;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/rank/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // ランク設定データ取得
          vm.items = response.data;
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },

    closeEdit() {
      this.getRankSetting();
    },
  },
};
</script>
